import React, { useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { getRestoLogin, toastStyle } from "../../Helpers/Utils/Common";

//components
import Table from "../../Components/TableTemplate/Table";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import ViewModal from "../../Components/Modals/ViewModal";
import EditModal from "../../Components/Modals/EditModal";
import InputError from "../../Components/InputError/InputError";

//css
import "../../cssFiles/CategoryManager.css";

//api
import { refreshPage } from "../../Helpers/Utils/Common";
import { validateCategory } from "../../Helpers/Validation/Admin/CategoryManager";
import {
  createCategories,
  deleteCategories,
  // searchCategories,
  updateCategories,
} from "../../Helpers/apiCalls/categoriesManagerApi";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import { useEffect } from "react";

export default function CategoryManager() {
  const [inactive, setInactive] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  // MODALS //
  // ROWS
  const [selectedRow, setSelectedRow] = useState({});
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  // VIEW
  const [showViewCategoryModal, setShowViewCategoryModal] = useState(false);
  const handleCloseViewCategoryModal = () => setShowViewCategoryModal(false);
  // EDIT
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const handleshowEditCategoryModal = () => setShowEditCategoryModal(true);
  const handleCloseEditCategoryModal = () => setShowEditCategoryModal(false);
  // ADD
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const handleshowAddCategoryModal = () => setShowAddCategoryModal(true);
  const handleCloseAddCategoryModal = () => setShowAddCategoryModal(false);
  //API
  const [categories, setCategories] = useState([]);
  const [editCategory, setEditCategory] = useState({});
  const [addCategory, setAddCategory] = useState({
    name: "",
  });
  const [searchText, setSearchText] = useState("");

  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    name: false,
  });
 

  //DROPDOWN
  function handleSelectChange(e, row) {
    setSelectedRow(row);
    setEditCategory(row);
    if (e.target.value === "delete-category") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-category") {
      handleshowEditCategoryModal();
    } else {
      refreshPage();
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={option}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        {/* <option value="view-user" className="color-options">View</option> */}
        <option value="edit-category" className="color-options">
          Edit
        </option>
        <option value="delete-category" className="color-red">
          Delete
        </option>
      </Form.Select>
    );
  }

  // getAllCategories
  // async function fetchCategories() {
  //   setShowLoader(true);
  //   const response = await UseGetRequest(
  //     "categories/getAll",
  //     {},
  //     getRestoLogin()
  //   );
  //   if (response.data) {
  //     setCategories(response.data.categories);
  //   } else {
  //     setCategories([]);
  //   }
  //   setTimeout(() => setShowLoader(false), 1000);
  // }

  async function searchCategory(name) {
    setShowLoader(true);
    // const response = await searchCategories(name);
    const response = await UseGetRequest(
      "categories/search",
      { term: name },
      getRestoLogin()
    );
    if (response.data) {
      setCategories(response.data);
    } else {
      setCategories([]);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  // ----------------------------------------------------------------------------------------------------------
  //ADD or CREATE CATEGORY
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddCategory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //Create API Category
  async function createCategory() {
    if (validateCategory(addCategory, setIsError)) {
      setIsClicked(true);
      const response = await createCategories(addCategory, getRestoLogin());
      if (response.data) {
        toast.success("Successfully Created Category!", {
          style: toastStyle(),
        });
        handleCloseAddCategoryModal();
        refreshPage();
      } else {
        toast.error(response.error.data.messages.error, {
          style: toastStyle(),
        });
      }
    } else {
      toast.error("An error has occured!", { style: toastStyle() });
    }
  }

  //EDIT or UPDATE CATEGORY
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditCategory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  async function updateCategory() {
    if (validateCategory(editCategory, setIsError)) {
      const response = await updateCategories(editCategory, getRestoLogin());
      if (response.data) {
        toast.success("Successfully Updated Category!", {
          style: toastStyle(),
        });
        handleCloseEditCategoryModal();
        refreshPage();
      } else {
        toast.error("Error Updating New Category", { style: toastStyle() });
      }
    } else {
      toast.error("Category name is required!", { style: toastStyle() });
    }
  }

  //View On Edit Category
  function handleOnEdit() {
    handleCloseViewCategoryModal();
    handleshowEditCategoryModal();
  }

  //DELETE or REMOVE MENU
  async function handleDeleteCategory() {
    const response = await deleteCategories(selectedRow.id, getRestoLogin());
    if (response.data) {
      toast.success("Successfully Deleted Category!", { style: toastStyle() });
      handleCloseDeleteModal();
      refreshPage();
    } else {
      toast.error(response.error.data.messages.error, { style: toastStyle() });
    }
  }

  useEffect(() => {
    // fetchCategories();
    searchCategory([]);
  }, []);

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page">
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Categories"}
          page={"Categories"}
        />
      </div>
      <div className={`container ${inactive ? "inactive" : "active"}`}>
        <Row className="my-3">
          <Col xs={6}>
            <label className="page-title-menu"> CATEGORY MANAGER </label>
          </Col>
          <Col xs={4} className="d-flex justify-content-end">
            <Input
              suffix={<SearchOutlined />}
              placeholder="Search category"
              className="h-100"
              onKeyDown={(e) =>
                e.key === ("Enter" || "NumpadEnter") && searchCategory(searchText)
              }
              onChange={(e) => {
                setSearchText(e.target.value)
                if (e.target.value==="") {
                  searchCategory(e.target.value)
                }
                
              }}
            />
          </Col>
          <Col xs={2}>
            <button
              className="category-new-export-btn"
              onClick={handleshowAddCategoryModal}
            >
              Add
            </button>
          </Col>
        </Row>
        <div className="table-content">
          {/* TABLE */}
          <Table
            tableHeaders={["CATEGORY", "ACTIONS"]}
            headerSelector={["name"]}
            tableData={categories}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
          />
        </div>
      </div>
      {/* MODALS */}
      <DeleteModal
        text="category"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteCategory}
      />
      <AddModal
        title="CATEGORY"
        type="user"
        show={showAddCategoryModal}
        onHide={handleCloseAddCategoryModal}
        onSave={createCategory}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row">
            <Col>
              CATEGORY
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                value={addCategory.name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Category is Required"}
              />
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="CATEGORY"
        type="menu"
        show={showEditCategoryModal}
        onHide={handleCloseEditCategoryModal}
        onSave={updateCategory}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row">
            <Col xl={12}>
              CATEGORY
              <Form.Control
                type="text"
                name="name"
                // id={editCategory.updated_by}
                value={editCategory.name}
                // defaultValue={selectedRow.name}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Category is Required"}
              />
            </Col>
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewCategoryModal}
        onHide={handleCloseViewCategoryModal}
        onEdit={handleOnEdit}
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              CATEGORY DETAILS
            </span>
            <div className="mt-3 container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col lg={12}>
                  CATEGORY
                  <Row className="nc-modal-custom-row">
                    <Col> {selectedRow.name} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
      <div>
        <label className="powered-label pt-3 text-center">
          Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
        </label>
      </div>
    </div>
  );
}
